import Reveal from "@/components/base/Reveal";
import { results, testimonials } from "@/mocks/home";

export default function Results() {
  return (
    <section className="relative bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-content px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.25em] text-primary-600">RESULTS</span>
          <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-5xl">
            숫자로 확인하는
            <br />
            성장의 기록
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-4 md:grid-cols-3">
          {results.map((item, idx) => (
            <Reveal key={item.label} delay={idx * 80}>
              <div className="h-full rounded-2xl bg-primary-500 p-7 text-foreground-950">
                <p className="font-heading text-4xl font-black tracking-tight md:text-5xl">
                  {item.value}
                </p>
                <p className="mt-3 font-heading text-base font-bold">{item.label}</p>
                <p className="mt-1 font-label text-xs tracking-wide text-foreground-950/60">
                  {item.sub}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid gap-4 md:grid-cols-3">
          {testimonials.map((review, idx) => (
            <Reveal key={review.name} delay={idx * 80}>
              <figure className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6">
                <i className="ri-double-quotes-l text-3xl text-primary-500" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">
                  {review.quote}
                </blockquote>
                <figcaption className="mt-5 border-t border-background-200 pt-4">
                  <span className="font-heading text-sm font-bold text-foreground-950">
                    {review.name}
                  </span>
                  <span className="ml-2 font-label text-xs text-foreground-600">
                    {review.grade}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}